import { Domains } from "../../data/Domains";
import { VillageRulesDto } from "../../dtos/VillageRulesDto";


export const getCurrentVillageRule = ( domain: Domains, villageRules: VillageRulesDto[], isThirdParty?: boolean ): VillageRulesDto | undefined => {

    if( domain === Domains.Bma ) {

        return villageRules.find( vr => vr.endDateTime.toString()[0] === '0' && vr.isThirdParty === isThirdParty );

    } else {

        return villageRules.find( vr => vr.endDateTime.toString()[0] === '0' );

    }

};